export default [
    {
      path: '/member',
      name: '成员分组', // 成员
      component: () => import(/* webpackChunkName: "member" */ '@/views/Member/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/member/newGroup',
      name: 'newGroup', // 新建分组
      component: () => import(/* webpackChunkName: "newGroup" */ '@/views/Member/newGroup/newGroup.vue')
    },
    {
      path: '/member/groupDetails',
      name: '分组详情', // 分组详情
      component: () => import(/* webpackChunkName: "groupDetails" */ '@/views/Member/groupDetails/groupDetails.vue')
    },
    {
      path: '/member/groupDetails/subGrouped',
      name: '小组', // 小组1
      component: () => import(/* webpackChunkName: "subgroup" */ '@/views/Member/groupDetails/subGrouped.vue')
    },
    {
      path: '/member/groupDetails/Ungroup',
      name: '未分组学生', // 未分组学生
      component: () => import(/* webpackChunkName: "Ungrouped" */ '@/views/Member/groupDetails/Ungroup.vue')
    },
    {
      path: '/member/groupDetails/remove',
      name: '移除组员', // 移除组员
      component: () => import(/* webpackChunkName: "remove" */ '@/views/Member/groupDetails/remove.vue')
    },
    {
      path: '/member/groupDetails/groupLeader',
      name: '设定组长', // 设定组长
      component: () => import(/* webpackChunkName: "remove" */ '@/views/Member/groupDetails/groupLeader.vue')
    },
    {
      path: '/member/groupDetails/SelectionGroup',
      name: 'groupDetails_SelectionGroup', // 选择加入的小组
      component: () => import(/* webpackChunkName: "remove" */ '@/views/Member/groupDetails/SelectionGroup.vue')
    },
    {
      path: '/member/groupDetails/groupSettings',
      name: '分组设置', // 分组设置
      component: () => import(/* webpackChunkName: "newGroup_groupSettings" */ '@/views/Member/groupDetails/groupSettings.vue')
    },
    {
      path: '/member/studentInfo/studentInfo',
      name: 'newGroup_studentInfo', // 学生信息
      component: () => import(/* webpackChunkName: "newGroup_groupSettings" */ '@/views/Member/studentInfo/studentInfo.vue')
    },
    {
      path: '/member/newTeam',
      name: '新建小组', // 新建小组
      component: () => import(/* webpackChunkName: "newGroup_newTeam" */ '@/views/Member/NewTeam/newTeam.vue')
    },
    {
      path: '/member/memberSetting',
      name: 'memberSetting', // 成员设置
      component: () => import(/* webpackChunkName: "newGroup_newTeam" */ '@/views/Member/memberSetting.vue')
    },
  ]